define([
    "jquery",
    "underscore",
    "marionette",
    "models/account/phone_email_model",
    "models/account/contact_method_model",
    "models/account/settlement_account_model",
    "qrcode",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    'bootstrap',
    "holdon"
], function($, _, Marionette, PhoneEmailModel, ContactMethodModel, SettlementAccountModel, QRCode, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'mt4AccountNo':'#mt4_account_no',

            'submitPhoneEmailBtn':'.submit_phone_email',
            'changePhoneEmailForm': '#change_phone_email_form',

            'submitContactMethodBtn':'.submit_contact_method',
            'changeContactMethodForm': '#change_contact_method_form',

            'submitSettlementAccountBtn':'.submit_settlement_account',
            'changeSettlementAccountForm': '#change_settlement_account_form',

            'currentSettlementAccount':'#current_settlement_account',
            'settlementAccountNumber':'#settlement_account_number',

            'changeSettlementAccountModal':'#change_settlement_account',
            'emptyAble' : '.empty-able',

            'qrCodeImg' : '.profile_link img',
            'qrCodeModal' : '#qr-code-modal',
            'qrCodeCanvas' : '#qr-code-canvas',
            'qrCodeDownload' : '#qr-code-download',
            'copyBtn' : '.copy-btn'
        },

        events:{
            'click @ui.submitPhoneEmailBtn': function(e){

                e.preventDefault();
                this.submitModel = new PhoneEmailModel();
                this.submit(e, this.ui.changePhoneEmailForm);
            },

            'click @ui.submitContactMethodBtn': function(e){

                e.preventDefault();
                this.submitModel = new ContactMethodModel();
                this.submit(e, this.ui.changeContactMethodForm);
            },

            'click @ui.submitSettlementAccountBtn': function(e){

                e.preventDefault();
                this.submitModel = new SettlementAccountModel();

                // We listen to the trade_account_number update to trigger the change of displayed account number
                this.listenTo(this.submitModel, 'change:trade_account_no', this.updateSettlementAccount);
                this.submit(e, this.ui.changeSettlementAccountForm);
            },

            'click @ui.qrCodeImg': 'openQrModal',
            'click @ui.copyBtn': 'copyUrl',
            'click @ui.qrCodeDownload': 'downloadQrCode',

            'keyup @ui.emptyAble' : 'setEmptyInputClass',
            'change @ui.emptyAble': 'setEmptyInputClass'
        },

        setEmptyInputClass : function(e){
            var val = $(e.currentTarget).val();
            if(val == "" || val.length == 0 ){
                $(e.currentTarget).toggleClass("empty_input", true)
            } else {
                $(e.currentTarget).toggleClass("empty_input", false)
            }
        },

        updateSettlementAccount: function (model) {
            $(this.ui.currentSettlementAccount).val(model.get('trade_account_no'));
            $(this.ui.settlementAccountNumber).html(model.get('trade_account_no'));
        },

        openQrModal: function (e) {
            $(this.ui.qrCodeCanvas[0]).data('filename', $(e.currentTarget).data('filename'));
            QRCode.toCanvas(this.ui.qrCodeCanvas[0], $(e.currentTarget).data('url'));
            this.ui.qrCodeModal.modal('show');
        },

        downloadQrCode: function (e) {
            const canvas = this.ui.qrCodeCanvas[0];
            const filename = $(canvas).data('filename');
            const imageURL = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imageURL;
            link.download = filename + '.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        copyUrl: function(e) {
            const url = $(e.currentTarget).data('url');

            if (navigator.clipboard) {
                navigator.clipboard.writeText(url);
            } else {
                // depreciated but still useful locally
                const textArea = document.createElement('textarea');
                textArea.value = url;
                textArea.style.position = 'fixed';  // Prevent scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                const successful = document.execCommand('copy');
                const msg = successful ? 'successful' : 'unsuccessful';

                document.body.removeChild(textArea);
            }
            this.showTooltip(e);
        },

        showTooltip: function(e) {
            const tooltip = $(e.currentTarget).next();
            tooltip.addClass('show-tooltip');
            setTimeout(() => {
                tooltip.removeClass('show-tooltip');
            }, 2000);
        },

        initialize: function(){
            this.bindUIElements();
        },

        submit: function(e, formUi) {
            e.preventDefault();
            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize( formUi);
            this.submitModel.set( formData);

            var errors = this.submitModel.validate();
            var that = this;

            if(_.size(errors) < 1){
                HoldOn.open({
                    theme:"sk-fading-circle"
                });
                this.submitModel.save(null, {
                    type: 'POST',
                    success: function(model, res){

                        that.triggerMethod('show:success', res);

                        that.ui.changeSettlementAccountModal.modal('hide')

                        HoldOn.close();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            }else{
                if(window.lang === 'ko_KR' && 'phone' in errors) errors['phone'] = '전화번호은(는) 유효한 입력값이 아닙니다.';
                this.triggerMethod('show:errors', errors);
            }
        }

    });
});
